import React from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png';
import img from '../assets/images/landing-page/collection-banner-carousel--collection-cover-art.png';

const Upload2 = ({ prevStep, nextStep, handleChange, values, removeItems }) => {

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const getImageAsData = image => {
        return URL.createObjectURL(image);
    }

    function preventDefault(e) {
        e.preventDefault();
        e.stopPropagation();
    }   

    
    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        // var data = e.dataTransfer,
        // files = data.files;
 
        handleChange('itemImageDrop')(e);
    }

    return (
        <div className="main-wrapper">
            {/* Header area start */}
            <nav className="navbar navbar-light justify-content-between">
                <Link to="/" className="navbar-brand"><img src={logo} alt="logo" /> Lorem</Link>
                <div className="justify-content-between">
                    {/* <Link to="#"><i className="fa fa-search" aria-hidden="true"></i></Link>&emsp;
                    <Link to="/Drops">Drops</Link>&emsp;
                    <Link to="/Marketplace">Marketplace </Link> */}
                    <div className="dropdown">
                        <button className="dropbtn"><i className="fa fa-user" aria-hidden="true"></i></button>
                        <div className="dropdown-content text-left">
                            <Link to="/AccountInfo">Account Info</Link>
                            <Link to="#">Account Activity</Link>
                            <Link to="#">Connect Wallet</Link>
                            <Link to="/UserProfileBuyer">Buyer Profile</Link>
                            <Link to="/CollectionDetails">Add New Collections</Link>
                            <Link to="/LoginSignup">Login</Link>
                        </div>
                    </div>
                </div>
            </nav>
            {/* Header area end */}

            {/* Form area start */}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 text-center form-area">
                        <h1 className="text-center">Submit New Collection</h1>

                        {/* Progressbar start */}
                        <ul id="progress-bar" className="progressbar">
                            <li className="active">COLLECTION</li>
                            <li className="active">UPLOAD ITEMS</li>
                            <li>ITEM DETAILS</li>
                            <li>REVIEW & SUBMIT</li>
                        </ul>
                        {/* Progressbar end */}
                    </div>
                </div>
            </div>

            {/* multistep form start*/}
            <div className="container text-center margin-70 arrow">
                <button onClick={Previous}>&#10229;</button>
                <h1>Upload Items<br /><span>{values.collectionTitle}</span></h1>
                <button disabled={values.items.length === 0} onClick={Continue} >&#10230;</button>
            </div>
            <div className="container mb-5">
                <div className="text-left uploaded">
                    { values.items.length > 0 ? <h6>{values.items.length} Files Uploaded <span style={{cursor: 'pointer'}} onClick={removeItems}>Remove All</span></h6> : null }                    
                    { values.items.map((item, index) => { return <img src={getImageAsData(item.image)} key={index} alt="" /> }) }
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-6 upload-area collection-area text-center">
                        <div className="upload-item" onDragOver={preventDefault} onDragEnter={preventDefault} onDrop={(event) => handleDrop(event)}>
                            <i className="fa fa-cloud-upload fa-5x upload-icon"></i>
                            <h1>Upload items</h1>
                            <h3>Drag and Drop</h3>
                            <p>or</p>
                            <input type="file" onChange={handleChange('itemImage')} multiple className="d-none" id="item-image-input" />
                            <button 
                                type="button" 
                                className="p-0"
                            ><label 
                                className="mb-0 btn p-2" 
                                for="item-image-input"
                                style={{cursor: 'pointer'}}
                            >Browse</label>
                            </button>
                            <h6>You can submit up to 15 items per collection.</h6>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
                            minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex</p>
                    </div>
                </div>
            </div>
            {/* multistep form end*/}

            {/* Form area end */}
        </div >
    )
}

export default Upload2